var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.permission
    ? _c("el-alert", {
        attrs: {
          title: "无权限操作",
          description: "请返回，或通知系统管理赋予你对该操作的权限。",
          type: "error",
          "show-icon": "",
          center: "",
          closable: false
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }